import { createGlobalStyle } from "styled-components";


export const Globalstyles = createGlobalStyle`
  body{
    background-color: black;
    font-family: 'Poppins',Verdana, Geneva, Tahoma, sans-serif;
    color:white;
    margin:0;
    top:0;
    left:0;
    right:0;
    bottom:0;
    
  }
  
  
  `